import PageNav from "../../Components/PageNav";
import Dashboard from "../../Components/Dashboard";
import useNewDataFetcher from "../../Hooks/newUseDataFetcher";
import "./style.scss";

function AltusTeamDashboard() {
  const { data: apiData, isReady } = useNewDataFetcher({ endPoint: "/api/v1/dashboard/altus-team" });
  let { json, data } = apiData || { json: [], data: [] };
  return (
    <>
      <PageNav title="Altus Team Dashboard" />
      <Dashboard json={json} data={data} isReady={isReady} />
    </>
  );
}

export default AltusTeamDashboard;
